import { render, staticRenderFns } from "./goAppShopAppDetail.vue?vue&type=template&id=51ce175c&scoped=true&"
import script from "./goAppShopAppDetail.vue?vue&type=script&lang=js&"
export * from "./goAppShopAppDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ce175c",
  null
  
)

export default component.exports